import { render, staticRenderFns } from "./AdCampaigns.vue?vue&type=template&id=92204628&scoped=true"
import script from "./AdCampaigns.vue?vue&type=script&lang=ts"
export * from "./AdCampaigns.vue?vue&type=script&lang=ts"
import style0 from "./AdCampaigns.vue?vue&type=style&index=0&id=92204628&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92204628",
  null
  
)

export default component.exports